<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="标题" prop="name">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
<!--    <a-form-model-item label="副标题" prop='nameEn'>-->
<!--      <a-input v-model="form.data.nameEn"/>-->
<!--    </a-form-model-item>-->
    <a-form-model-item label="描述">
      <a-textarea :autosize="{minRows:4}" v-model="form.data.description"/>
    </a-form-model-item>
    <a-form-model-item label="描述英文">
      <a-textarea :autosize="{minRows:4}" v-model="form.data.descriptionEn"/>
    </a-form-model-item>
    <a-form-model-item label="是vip?" prop="isVip">
      <dict-select
        v-model="form.data.isVip"
        dict-code="SIMPLE_STATUS"/>
    </a-form-model-item>
    <a-form-model-item label="图片封面(375*375)" prop='coverPath'>
      <div class="a-input">
        <cropper-uploader
          v-model="form.data.coverPath"
          :imageUrl="form.data.coverPath"
          :options="coverOptions"
          avatarTextTop=""
          avatarTextBottom=""/>
      </div>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
      <a-button type="primary" v-if="!goodsSeriesId" @click="onAdd">创建</a-button>
      <a-button type="primary" v-if="goodsSeriesId" @click="onUpdate">更新</a-button>
      <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryGoodsSeries,
  _addGoodsSeries,
  _updateGoodsSeries,
} from '@/api/goodsSeriesApi';
import SimpleUploader from '@/components/SimpleUploader.vue';
import DictSelect from '../../../components/DictSelect.vue';
import CropperUploader from '@/components/CropperUploader.vue';

async function getGoodsSeries() {
  const result = await _queryGoodsSeries(this.goodsSeriesId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.coverPath = result.coverPath;
    this.form.data.nameEn = result.nameEn;
    this.form.data.description = result.description;
    this.form.data.isVip = result.isVip;
    this.form.data.descriptionEn = result.descriptionEn;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addGoodsSeries({
        name: this.form.data.name,
        coverPath: this.form.data.coverPath,
        nameEn: this.form.data.nameEn,
        description: this.form.data.description,
        isVip: this.form.data.isVip,
        descriptionEn: this.form.data.descriptionEn,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateGoodsSeries(this.goodsSeriesId, {
        name: this.form.data.name,
        coverPath: this.form.data.coverPath,
        nameEn: this.form.data.nameEn,
        description: this.form.data.description,
        isVip: this.form.data.isVip,
        descriptionEn: this.form.data.descriptionEn,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'GoodsSeriesEdit',
  components: {
    CropperUploader,
    // SimpleUploader,
    DictSelect,
  },
  props: {
    goodsSeriesId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    goodsSeriesId() {
      if (this.goodsSeriesId) {
        this.getGoodsSeries();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getGoodsSeries,
  },
  data() {
    return {
      form: {
        data: {
          name: '',
          coverPath: '',
          nameEn: '',
          description: '',
          isVip: 'NO',
          descriptionEn: '',
        },
        rules: {
          name: [{ required: true, trigger: 'blur' }],
          nameEn: [{ required: true, trigger: 'blur' }],
          coverPath: [{ required: true, trigger: 'blur' }],
          isVip: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
      coverOptions: {
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 375, // 默认生成截图框宽度
        autoCropHeight: 375, // 默认生成截图框高度
        fixedBox: false, // 是否固定截图框大小 不允许改变
        previewsCircle: false, // 预览图是否是圆形
        serviceType: 'OSS',
        title: '修改图片',
      },
    };
  },
  created() {
    if (this.goodsSeriesId) {
      this.getGoodsSeries();
    }
  },
};
</script>
